import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { GPSyncStatus } from "fe-shared/src/components";
import { InvoicePeriodWrapper, InactiveStatus } from "..";

import { Invoice, InvoiceItemType } from "../../types";

import styles from "./InvoiceHeaderInfo.module.scss";

interface Props {
  invoice: Invoice;
  isStaffView?: boolean;
}

const InvoiceHeaderInfo = ({
  invoice: {
    periodEndDate,
    periodStartDate,
    objectIds,
    invoiceNumber,
    company,
    invoiceTarget,
    synchronizationStatusCode,
  },
  isStaffView = false,
}: Props) => {
  const { t } = useTranslation();

  const companyContent = isStaffView ? (
    <>
      <Link to={`/participants/${company?.id}`}>
        {`#${company?.regNumber}`}
      </Link>
      {!!company && !company?.isActive && (
        <>
          <span>{" · "}</span>
          <InactiveStatus />
        </>
      )}
    </>
  ) : (
    `#${company?.regNumber}`
  );

  return (
    <>
      <div className={styles.roleInfo}>
        <span>{`${t(`businessRoles.${company?.businessRole}`)} · `}</span>
        {companyContent}
      </div>
      <div className={styles.invoiceHeader}>
        <h1 className={styles.invoiceHeaderTitle}>{company?.displayName}</h1>
        {!!synchronizationStatusCode && (
          <GPSyncStatus synchronizationStatusCode={synchronizationStatusCode} />
        )}
      </div>
      <InvoicePeriodWrapper
        startDate={periodStartDate}
        endDate={periodEndDate}
        count={objectIds.length}
        invoiceNumber={invoiceNumber}
        isWithTransactions={invoiceTarget === InvoiceItemType.Transaction}
      />
    </>
  );
};

export default InvoiceHeaderInfo;
